import { Modal, Icon, Button } from "@tecma/ds";
import { useTranslation, Trans } from "@tecma/i18n";

import "./new-user-modal.scss";

interface Params {
  isOpen: boolean;
  onClose: () => void;
  onRedirectToMyHome: () => void;
}

export const NewUserModal = ({
  isOpen,
  onClose,
  onRedirectToMyHome,
}: Params) => {
  const { t } = useTranslation();
  return (
    <Modal className='new-user-modal' isOpen={isOpen} onClose={onClose}>
      <Modal.Header onClose={onClose} closeIcon>
        <span>{t("new-user-modal.title")}</span>
      </Modal.Header>
      <Modal.Content>
        <Icon iconName='check-circle' size='large' />
        <Trans
          i18nKey='new-user-modal.description'
          components={{
            p: <p />,
            span: <span />,
          }}
        />
      </Modal.Content>
      <Modal.Footer>
        <Button rounded fluid onClick={onRedirectToMyHome}>
          {t("new-user-modal.button")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
